import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { MdOutlinePersonOutline } from 'react-icons/md';
import { AssociatedRecord } from 'apis/business/agent/contact/types';

type Props = {
  records: AssociatedRecord[] | undefined;
};

function recordLabel(record: AssociatedRecord): string {
  const name = [record.first_name, record.last_name].filter(Boolean).join(' ').trim();
  return name || 'Unknown Caller';
}

export default function IntegrationRecords({ records }: Props) {
  const theme = useTheme();
  const count = records?.length ?? 0;
  const labels = (records ?? []).map(recordLabel);
  const tooltip = labels.length > 0 ? labels.join(', ') : 'No integration records';

  return (
    <Tooltip title={tooltip} arrow placement='top'>
      <Box
        display='inline-flex'
        alignItems='center'
        gap={0.75}
        px={1}
        py={0.5}
        borderRadius={1}
        sx={{
          bgcolor: theme.palette.primary.light,
          color: theme.palette.primary.main,
          cursor: 'default'
        }}
      >
        <MdOutlinePersonOutline size={18} />
        <Typography variant='body2' fontWeight={500} color='inherit' lineHeight={1}>
          {count}
        </Typography>
      </Box>
    </Tooltip>
  );
}
